export default "__VITE_ASSET__DhzkpE3i__"